/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Slider from "react-slick";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Reviews() {
  const settings = {
    className: "slider variable-width",
    infinite: false,
    // centerMode: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    // variableWidth: true,
    autoplay: true,
    autoplaySpeed: 2000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1024, // tablets and smaller
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          variableWidth: false,
          centerMode: true,
        },
      },
      {
        breakpoint: 768, // phones
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: true,
        },
      },
      {
        breakpoint: 480, // smaller phones
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false, // optional: center mode off for narrow screens
        },
      },
    ],
  };

  const reviews = [
    {
      name: "Anna",
      message:
        "We had a very good experience with Hee Plumbing. They were responsive to our inquiry and scheduled a visit at a convenient time. The team arrived on time and was friendly throughout the process. They explained the plumbing issues clearly and handled the repairs efficiently. We would recommend their services for anyone needing plumbing assistance.",
    },
    {
      name: "Faiz Kamsir",
      message:
        "Engaged their services for my new house and everything went smooth. Very professional and efficient work. Even helped to clean out my pipe. Highly recommend their work to everyone out there who needs their plumbing problem fixed!",
    },
    {
      name: "Boon Tai",
      message:
        "Thiam provides careful assessment of the issues before embarking on any work. I am happy with the wide range of repairs and replacements of water heaters, taps and also lights and heater switches he has done for me over the years. He can be trusted to complete the job to your satisfaction.",
    },
    {
      name: "Cheryl C (holipiggy)",
      message:
        "My kitchen sink pipes were suddenly leaking water and my mum was giving me a hard time expecting me to fix the issue immediately. I reached out to Thiam and they came over within a couple of hours and was able to solve my problem promptly and efficiently. They even did a check for my existing pipes to make sure they don't start leaking too! Truly my real life Super Mario hero =P Highly recommended!! ◡̈",
    },
    {
      name: "Nisa Khan",
      message:
        "The service rendered by Thiam was superb and excellent . He took the trouble to troubleshoot the actual issue and fix it . Thank you for the excellent service . Appreciate it very much",
    },
    {
      name: "Syafiq Perwira",
      message:
        "Over the years, I have had the pleasure of having Thiam to work on some of my plumbing issues at home and at my studio. He has always ensured quality work and professional service throughout the time that I needed him to attend to my issues. He made sure that he gives the best of service and advices me based on what I need rather than giving me unnecessary add ons. Thank you Thiam for being professional and honest in your service. Cheng",
    },
    {
      name: "Sebastian Ong",
      message:
        "Had the pleasure of working with Thiam from Hee Plumbing & Sanitary during my home renovation — and he truly delivered. Everything was done with precision, no corners cut, and his team was efficient, punctual, and professional. Any hiccup was met with a solid solution. Couldn’t have asked for better service. Highly recommend, and he’s my go-to from now on and for any referrals. Thank you Thiam",
    },
  ];

  return (
    <MKBox
      id="review"
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h2" color="white">
              OUR REVIEWS
            </MKTypography>
          </Grid>
        </Grid>
        <Slider {...settings} spacing={3}>
          {reviews.map((review, i) => (
            <div key={i} className="slider-container">
              <MKBox mb={1} mx={1}>
                <DefaultReviewCard
                  key={review.name}
                  color="info"
                  name={review.name}
                  rating={5}
                  review={review.message}
                />
              </MKBox>
            </div>
          ))}
        </Slider>
      </Container>
    </MKBox>
  );
}

export default Reviews;
